/**
 * Web build counterpart to `@env`. Webpack aliases `@env` to this file.
 *
 * The actual substitution happens via webpack.DefinePlugin which replaces
 * `process.env.X` references in our bundle with the literal value loaded
 * from `.env` (via `require('dotenv').config()` in webpack.config.js).
 *
 * Keep this list in sync with `.env.example`.
 */
export const COGNITO_USER_POOL_ID        = process.env.COGNITO_USER_POOL_ID        || '';
export const COGNITO_USER_POOL_CLIENT_ID = process.env.COGNITO_USER_POOL_CLIENT_ID || '';
export const COGNITO_REGION              = process.env.COGNITO_REGION              || '';
